<template>
  <div class="sidebar__nav__menu" :class="{ 'open' : open}">
    <a @click.prevent="clickMainLink($event, 'club')" class="sidebar__nav__link" href="/wine-club">Club</a>
    <a @click.prevent="clickMainLink($event, 'shop')" class="sidebar__nav__link" href="/shop">Shop</a>
    <a @click.prevent="clickMainLink($event, 'visit')" class="sidebar__nav__link" href="/visit">Visit</a>
    <a @click.prevent="clickMainLink($event, 'more')" class="sidebar__nav__link" href="">More</a>

    <transition-group name="fade_down" mode="out-in">
      <div v-show="open === 'club'" class="sidebar__nav__child" key="club">
        <a class="sidebar__nav__link" href="/wine-club">Details</a>
        <a class="sidebar__nav__link" href="/wine-club/join">Join</a>
        <a class="sidebar__nav__link" href="/wine-club/member-lounge">Members</a>
      </div>
    
      <div v-show="open === 'shop'" class="sidebar__nav__child" key="shop">
        <a class="sidebar__nav__link" href="/shop/individual-wines">Wines</a>
        <a class="sidebar__nav__link" href="/shop/cases-and-packages">Cases & Packages</a>
        <a class="sidebar__nav__link" href="/shop/merchandise">Merch</a>
      </div>
    
      <div v-show="open === 'visit'" class="sidebar__nav__child" key="visit">
        <a class="sidebar__nav__link" href="/visit">Visit</a>
        <a class="sidebar__nav__link" href="/events">Events</a>
        <a v-if="allowreservations == '1'" class="sidebar__nav__link" :href="reservationsurl" target="_blank" data-tock-reserve=true data-tock-experience-list=true>Reservations</a>
      </div>
    
      <div v-show="open === 'more'" class="sidebar__nav__child" key="more">
        <a class="sidebar__nav__link" href="/about">About</a>
        <a class="sidebar__nav__link" href="/contact">Contact</a>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  
  props: {
    allowreservations : {
      type: String,
      default: ''
    },
    reservationsurl: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      open: null
    }
  },

  methods: {
    clickMainLink(event, link) {
      if (this.open && this.open === link) {
        const href = event.target.getAttribute('href')
        if (href) {
          window.location = href
        } else {
          this.open = null
        }
      } else {
        this.open = link
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// _js/components/MainMenu.vue